import {isDev} from "../functions";

export default (isDev ? 'https://sepolia.drpc.org' : 'https://eth-sepolia.g.alchemy.com/v2/qupTO2ZW5SVtfWvlzUf2LsjXp_-MfgCl')